export const blockIconsAndroidAndroidNew = (
	<span className='material-symbols-outlined'>android</span>
);
